import { render, staticRenderFns } from "./ModalContent.vue?vue&type=template&id=74c955a4&scoped=true"
import script from "./ModalContent.vue?vue&type=script&lang=js"
export * from "./ModalContent.vue?vue&type=script&lang=js"
import style0 from "./ModalContent.vue?vue&type=style&index=0&id=74c955a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c955a4",
  null
  
)

export default component.exports